// API Service per visualizzazione video dal frontend web
const BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:3000"
    : process.env.REACT_APP_API_URL || "";

export interface VideoItem {
  _id: string;
  file: string;
  caption: string;
  tenant: string;
  createdAt: string;
  updatedAt: string;
}

export interface VideoListResponse {
  success: boolean;
  data: VideoItem[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
  error?: string;
}

/**
 * Recupera la lista dei video dalla tabella VideoForMake
 */
export const getWebVideoList = async (
  page = 1,
  limit = 50,
  tenant?: string,
  sortBy = "createdAt",
  sortOrder = "desc"
): Promise<VideoListResponse> => {
  try {
    let url = `${BASE_URL}/api/web/videos?page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
    if (tenant) {
      url += `&tenant=${encodeURIComponent(tenant)}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error: any) {
    console.error("Errore nel recupero dei video web:", error);
    throw new Error(
      error.message || "Errore nel recupero dei video"
    );
  }
};

/**
 * Ottiene l'URL per lo streaming di un video
 */
export const getVideoStreamUrl = (videoId: string): string => {
  return `${BASE_URL}/api/web/videos/${videoId}/stream`;
};

/**
 * Verifica che un video sia accessibile
 */
export const checkVideoAccess = async (videoId: string): Promise<boolean> => {
  try {
    const response = await fetch(getVideoStreamUrl(videoId), {
      method: "HEAD",
      credentials: "include",
    });
    return response.ok;
  } catch (error) {
    console.error("Errore nella verifica accesso video:", error);
    return false;
  }
};

/**
 * Ottiene statistiche sui video
 */
export const getVideoStats = async (): Promise<{
  total: number;
  byTenant: Record<string, number>;
}> => {
  try {
    const response = await getWebVideoList(1, 1000); // Carica tutti per stats
    const stats = {
      total: response.pagination.total,
      byTenant: {} as Record<string, number>,
    };

    // Conta per tenant
    response.data.forEach((video) => {
      if (stats.byTenant[video.tenant]) {
        stats.byTenant[video.tenant]++;
      } else {
        stats.byTenant[video.tenant] = 1;
      }
    });

    return stats;
  } catch (error) {
    console.error("Errore nel calcolo statistiche video:", error);
    return { total: 0, byTenant: {} };
  }
};

export default {
  getWebVideoList,
  getVideoStreamUrl,
  checkVideoAccess,
  getVideoStats,
};
